import { render, staticRenderFns } from "./IconEdit3.vue?vue&type=template&id=cfdafb62&"
import script from "./IconEdit3.vue?vue&type=script&lang=ts&"
export * from "./IconEdit3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports